import { DateTime } from "luxon"
import { Grid, Stack, Typography } from "@mui/material"

import { FormikTimePicker } from "../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

export function TimeIntervalField() {
    return (
        <Stack spacing=".5rem">
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <LocalizedStrict id="product-create-availability-from-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<never, DateTime>
                            name="availabilityDetails.timeInterval.start"
                            label="From time"
                            slotProps={{ field: { clearable: true } }}
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item xs={6}>
                    <LocalizedStrict id="product-create-availability-to-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<never, DateTime>
                            name="availabilityDetails.timeInterval.end"
                            label="To time"
                            slotProps={{ field: { clearable: true } }}
                        />
                    </LocalizedStrict>
                </Grid>
            </Grid>
            <LocalizedStrict id="product-create-availability-time-helper-text">
                <Typography variant="body2" color="text.secondary">
                    Leave both times empty to sell the product all day.
                </Typography>
            </LocalizedStrict>
        </Stack>
    )
}
